import createTxpDataRow from './createTxpDataRow';
import getReservationStatus from './getReservationStatus';
import DetailsIcons from '../../schema/configSchema/DetailsIcons';
import Reservation from '../../schema/Reservation';
import ReservationCardItem from '../../schema/viewSchema/ReservationCardItem';
import TxpStrings from '../../schema/configSchema/TxpStrings';

/**
 *  This function fills the Reservation Card Item with reservation status
 */
export default function createReservationCard(
    reservationEntity: Reservation,
    txpStrings: TxpStrings,
    detailsIcons?: DetailsIcons
): ReservationCardItem {
    return {
        reservationStatus: reservationEntity
            ? createTxpDataRow(
                  getReservationStatus(reservationEntity.reservationStatus, txpStrings),
                  null,
                  detailsIcons.warning
              )
            : null,
    } as ReservationCardItem;
}
